export default {
  1: 'mellat',
  2: 'saman',
}
